import { Alert } from "@mui/material";
import { motion } from "framer-motion";

export const Toast = ({
  message,
  severity,
  onClose,
  style,
}: {
  message: string;
  severity: "success" | "error" | "info" | "warning";
  onClose: () => void;
  style: React.CSSProperties;
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: 20 }}
      animate={{ opacity: 1, translateY: 0 }}
      exit={{ opacity: 0, translateY: 20 }}
      transition={{ duration: 0.2 }}
      style={{
        position: "fixed",
        right: 16,
        ...style,
        zIndex: 999999,
      }}
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={onClose}
        sx={{ boxShadow: 3 }}
      >
        {message}
      </Alert>
    </motion.div>
  );
};
